/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {TranscribeAudioRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_transcription_messages.pb'
import {TranscribeAudioResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_transcription_messages.pb'


export const transcribeAudio = (request: TranscribeAudioRequest, options?: CashRequestOptions) => post<TranscribeAudioRequest, TranscribeAudioResponse>("/2.0/cash/transcribe-audio", request, {...options, rejectOnError: true })